import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const createFontRequest = createAction(types.CREATE_FONT_REQUEST);
export const createFontSuccess = createAction(types.CREATE_FONT_SUCCESS);
export const createFontFailure = createAction(types.CREATE_FONT_FAILURE);

export const availableFontsRequest = createAction(
  types.AVAILABLE_FONTS_REQUEST,
);
export const availableFontsSuccess = createAction(
  types.AVAILABLE_FONTS_SUCCESS,
);
export const availableFontsFailure = createAction(
  types.AVAILABLE_FONTS_FAILURE,
);

export default {
  createFontRequest,
  createFontSuccess,
  createFontFailure,
  availableFontsRequest,
  availableFontsSuccess,
  availableFontsFailure,
};
